import { Dispatch } from "redux";
import { LeaveTransaction } from "../../types/LeaveTransaction";
import {
  getLeaveTransactions,
  getLeaveTransactionById,
  createLeaveTransaction,
  updateLeaveTransaction,
  deleteLeaveTransaction,
  getEmpLeaveBal,
} from "../../services/LeaveTransactionService";

/* ---------- Action Types ---------- */
export enum LeaveActionList {
  ADD_LEAVE = "ADD_LEAVE",
  EDIT_LEAVE = "EDIT_LEAVE",
  FETCH_LEAVES = "FETCH_LEAVES",
  FETCH_LEAVE_BAL = "FETCH_LEAVE_BAL",
  DELETE_LEAVE = "DELETE_LEAVE",
}

/* ---------- Action Interfaces ---------- */
export interface AddLeaveAction {
  type: LeaveActionList.ADD_LEAVE;
  data: LeaveTransaction;
}

export interface EditLeaveAction {
  type: LeaveActionList.EDIT_LEAVE;
  data: LeaveTransaction;
  id: number;
}

export interface FetchLeavesAction {
  type: LeaveActionList.FETCH_LEAVES;
  data: LeaveTransaction[];
}

export interface FetchLeaveBalanceAction {
  type: LeaveActionList.FETCH_LEAVE_BAL;
  data: LeaveTransaction[];
}

export interface DeleteLeaveAction {
  type: LeaveActionList.DELETE_LEAVE;
  data: number;
}

/* ---------- Action Type Grouping ---------- */
export type LeaveTransactionActions =
  | AddLeaveAction
  | EditLeaveAction
  | FetchLeavesAction
  | FetchLeaveBalanceAction
  | DeleteLeaveAction;

/* ---------- Action Creators ---------- */
export const fetchLeavesAction = () => {
  return async (dispatch: Dispatch) => {
    const response = await getLeaveTransactions();
    dispatch<FetchLeavesAction>({
      type: LeaveActionList.FETCH_LEAVES,
      data: response, // Adjust if your service returns differently
    });
  };
};
export const fetchLeavesBalanceAction = (employeeId: string) => {
  return async (dispatch: Dispatch) => {
    const response = await getEmpLeaveBal(employeeId);
    dispatch<FetchLeaveBalanceAction>({
      type: LeaveActionList.FETCH_LEAVE_BAL,
      data: response, // Adjust if your service returns differently
    });
    console.log(response);
  };
};

export const addLeaveAction = (data: LeaveTransaction) => {
  return async (dispatch: Dispatch) => {
    const response = await createLeaveTransaction(data);
    dispatch<AddLeaveAction>({
      type: LeaveActionList.ADD_LEAVE,
      data: response.data,
    });
  };
};

export const editLeaveAction = (id: number, data: LeaveTransaction) => {
  return async (dispatch: Dispatch) => {
    const response = await updateLeaveTransaction(id, data);
    dispatch<EditLeaveAction>({
      type: LeaveActionList.EDIT_LEAVE,
      data: response.data,
      id,
    });
  };
};

export const deleteLeaveAction = (id: number) => {
  return async (dispatch: Dispatch) => {
    await deleteLeaveTransaction(id);
    dispatch<DeleteLeaveAction>({
      type: LeaveActionList.DELETE_LEAVE,
      data: id,
    });
  };
};
